"use client"

import { ColorModeProvider } from "@/components/infrastructure/color-mode"
import { Toaster } from "@/components/infrastructure/toaster"
import { system } from "@/theme"
import { ChakraProvider } from "@chakra-ui/react"
import type { PropsWithChildren } from "react"

export function CustomProvider(props: PropsWithChildren) {
  return (
    <ChakraProvider value={system}>
      <ColorModeProvider defaultTheme="light">
        {props.children}
      </ColorModeProvider>
      <Toaster />
    </ChakraProvider>
  )
}
